// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1b3Hy","errorLogs":"styles_errorLogs__17oJg"};